// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b13f1f0042eb6032dfec","883":"3d65b2db7f0301ab880b"}[chunkId] + ".js";
};